import React from 'react';
import whatsIcon from '../../assets/whats.png';

import { Whats } from './styles';

interface IWhatsapp {
  number?: string;
  text?: string;
  message?: string;
  iconSize?: string;
  fontSize?: string;
  style?: Record<string, any>;
}

const WhatsappFixed: React.FC<IWhatsapp> = ({
  number = '55519939790138',
  text = 'Oi, estou em seu website!',
  message = '',
  iconSize = '30px',
  fontSize = '16px',
  style = {}
}) => {
  return (
    <Whats style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 10000000000 }}
      iconSize={'20px'}
      fontSize={fontSize}
      href={`https://api.whatsapp.com/send?l=pt&phone=${number}&text=${encodeURI(
        text,
      )}`}
      className="floater whatsapp shadow"
    >
      <img
        className=""
        src={whatsIcon}
        title="Whatsapp"
        alt="Whatsapp"
      />
      {message}
    </Whats>
  );
};

export default WhatsappFixed;
